<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <grant-wizard v-if="GrantForm.initialized" :is-editable="GrantForm.isEditable || (GrantForm.isRevisionEditable && GrantForm.isOnARevisionTab)">
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-settings-gear-63"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('small_technical_grants.general_information_tab')}}</p>
            </template>
            <step-general-informations></step-general-informations>
          </grant-wizard-tab>
          <!--<grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-puzzle-10"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('small_technical_grants.logical_framework_tab')}}</p>
            </template>
            <step-logical-framework></step-logical-framework>
          </grant-wizard-tab>-->
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-paper"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('small_technical_grants.general_information_esms_questions_tab')}}</p>
            </template>
            <step-esms-questionnaire></step-esms-questionnaire>
          </grant-wizard-tab>
          <grant-wizard-tab>
            <template slot="label">
              <i class="tim-icons icon-paper"></i>
            </template>
            <template slot="tabItemTitle">
              <p class="wizard-tab-title">{{$t('small_technical_grants.document_upload_tab')}}</p>
            </template>
            <step-document-upload></step-document-upload>
          </grant-wizard-tab>
        </grant-wizard>
      </div>
    </div>
  </div>
</template>
<script>
  import StepGeneralInformations from './Steps/GeneralInformations';
  import StepLogicalFramework from './Steps/LogicalFramework';
  import StepDocumentUpload from './Steps/DocumentUpload';
  import StepEsmsQuestionnaire from './Steps/EsmsQuestionnaire';

  import {EventBus} from '@/event-bus.js';
  import swal from 'sweetalert2';
  import {GrantWizard, GrantWizardTab} from 'src/components';
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    components: {
      GrantWizard,
      GrantWizardTab,
      StepGeneralInformations,
      StepLogicalFramework,
      StepDocumentUpload,
      StepEsmsQuestionnaire
    },
    created() {
      EventBus.$off('set-active-tab');

      EventBus.$on('wizard-save-progress', data => {
        this.onBeforeSaveProgress(data);
      });

      EventBus.$on('wizard-complete-progress', data => {
        this.onBeforeCompleteProgress(data);
      });
    },
    methods: {
      async onBeforeSaveProgress(data) {
        /*let valid = await this.validate();
        if (valid) {
          EventBus.$emit('grant-save-progress', data);
        }*/
        EventBus.$emit('grant-save-progress', data);
      },

      async onBeforeCompleteProgress(data) {
        let valid = await this.validate();
        if(GrantForm.isRevisionEditable){
            valid = true;
        }
        if (!valid) {
          return;
        }

        var submitConfirmation = await this.showPreSubmitNotification().then((result) => {
          return result.value ? true : false;
        });

        if (submitConfirmation) {
          EventBus.$emit('grant-complete-progress', data);
        }
      },

      async validate() {
        let valid = true;
        let vm = this;
        let mandatoryFields = [
          {
            translation: vm.$t('medium_grant.technical__1_region'),
            value: GrantForm.regionId
          },
          {
            translation: 'Start Date is required',
            value: GrantForm.model.technical.startDate
          },
          {
            translation: 'End Date is required',
            value: GrantForm.model.technical.endDate
          },
          {
            translation: 'Due diligence Questionnaire',
            value: GrantForm.files.technical.appDueDiligenceQuestionnaire
          },
          {
            translation: 'Application template',
            value: GrantForm.files.technical.appTemplateCompleted
          },
          {
            translation: 'Logical framework',
            value: GrantForm.files.technical.appLogicalFramework
          },
          {
            translation: 'Budget',
            value: GrantForm.files.technical.appCompletedBudgetTable
          },
          {
            translation: 'Declaration of the applicant',
            value: GrantForm.files.technical.appDeclaration
          },
        ];
GrantForm.files.technical.appDeclaration
        let errorFields = [];
        mandatoryFields.forEach(item => {
          if (item.value === undefined || !item.value || (Array.isArray(item.value) && !item.value.length)) {
            errorFields.push(item.translation);
          }
        })

        if (errorFields.length) {
          valid = false;
          if(!GrantForm.isRevisionEditable){
            await this.showNotificationMandatoryFields(errorFields);
          }
          

          EventBus.$emit('set-active-tab', {
            masterNickname: 'technical',
            masterIndex: 0,
            childIndex: 0,
            validate: true
          });
        }
        return valid;
      },

      showNotificationMandatoryFields(fields) {
        for (var i = 0; i < fields.length; i++) {
          fields[i] = "* " + fields[i];
        }
        let fieldsHtml = '<div class="text-danger">' + fields.join("<br>") + '</div>';
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__mandatory_fields', [fieldsHtml]).split("\n").join("<br>"),
          type: 'warning',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: 'OK'
        })
      },

      showPreSubmitNotification() {
        return swal.fire({
          title: this.$t('general.notification__warning'),
          html: this.$t('general.notification__pre_submit_application').split("\n").join("<br>"),
          type: 'warning',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-primary btn-fill',
          confirmButtonText: this.$t('general.notification__submit_application'),
          cancelButtonClass: 'ml-3 btn btn-danger btn-fill',
          cancelButtonText: this.$t('general.notification__cancel_submit_application'),
        })
      }
    }
  };
</script>
